import React from 'react'

const WhyUs = () => {
    return (
        <div className="flex flex-col gap-[64px] pb-[96px] max-2xl:px-[7.7vw] max-w-[1600px]">
            <div className="flex flex-col gap-[20px] max-w-[768px]">
                <div className="flex flex-col gap-[12px]">
                    <span className='text-[#F02E49] font-[600] '>
                        Why Choose Us
                    </span>
                    <h2 className='text-[#101828] sm:text-[36px] text-[32px] font-[600] '>
                        Empowering Clients: Certified DJ Business Support
                    </h2>
                </div>
                <span className='text-[#475467] sm:text-[20px] text-[16px] '>
                    Stress-Free Event Planning, Unforgettable Experiences
                </span>
            </div>
            <div className="flex max-md:flex-col items-start gap-[64px]">
                <p className='w-full text-[18px] text-[#475467`]'>
                    Planning an event can be overwhelming, especially when you want everything to be perfect. Whether it's a wedding, a corporate event, or a private party, the right DJ can make all the difference. That's where Certified DJs comes in – we take the hassle out of finding and booking the perfect DJ for your event.
                    <br />
                    <br />
                     Our platform connects you with top-notch DJs who have been thoroughly vetted for their skills and professionalism. You can browse through detailed profiles, read genuine reviews, and select the DJ who best fits the vibe and style of your event. Once you've chosen your DJ, you'll work together to create a customized music plan that matches your vision. From your favorite songs to the overall mood, our DJs will ensure that every detail of the music is just right, allowing you to relax and trust in their expertise to set the perfect tone for your event.
                </p>
                <p className='w-full text-[18px] text-[#475467`]'>
                    For our clients, Certified DJs offers a straightforward and secure payment process, ensuring your booking is hassle-free and your financial peace of mind is our top priority.
                </p>
            </div>
        </div>
    )
}

export default WhyUs